import { humanGrantRedeemableAmount } from '../../../../lib/PackageHelpers.js';
import ShipmentRemoveIcon from '../../../icons/ShipmentRemoveIcon.jsx';
import { useEventTypesQuery } from '../../../../lib/SharedQueries.js';
import usePublicPostApi from '~/public/lib/usePublicPostApi';
import { formatDate, formatDateLong } from '~/lib/DateTime';
import { isFuture } from 'date-fns';
import { formatCurrency } from '~/lib/CurrencyHelpers';

const UsedPackageGrantDetails = ({ grants, token, settings }) => {
    if (!grants?.length) {
        return null;
    }

    const { data: eventTypesData } = useEventTypesQuery();
    const { save: saveCancel, isSaving: isCanceling } = usePublicPostApi(
        `/event/${token}/subscription/cancel`,
    );

    function doCancel(grant) {
        if (confirm('Are you sure you want to cancel this subscription?')) {
            saveCancel({
                grant: grant.id,
            }).then(() => {
                document.location.reload();
            });
        }
    }

    return (
        <div className="text-center mb-4">
            {grants.map(grant => (
                <div>
                    <div className="font-medium flex items-center justify-center">
                        <ShipmentRemoveIcon className="w-4 h-4 themed-text mr-2" />
                        {grant.package?.name}{' '}
                        {grant?.redeemable_for?.type !== 'nothing' && (
                            <>
                                has{' '}
                                {humanGrantRedeemableAmount(
                                    grant,
                                    eventTypesData,
                                )}{' '}
                                remaining.
                            </>
                        )}
                    </div>
                    <div>
                        {!!grant.next_renewal_at &&
                            !grant?.package?.disable_cancellation && (
                                <div>
                                    <div>
                                        Renews{' '}
                                        {formatDateLong(grant.next_renewal_at)}{' '}
                                        for {formatCurrency(grant.price)}
                                    </div>
                                    <button
                                        type="button"
                                        className="form-button mt-2"
                                        onClick={() => doCancel(grant)}
                                    >
                                        {isCanceling
                                            ? 'Canceling...'
                                            : 'Cancel Subscription'}
                                    </button>
                                </div>
                            )}
                        {!grant.next_renewal_at && (
                            <div>
                                {!!grant.expires_at &&
                                    isFuture(new Date(grant.expires_at)) && (
                                        <div>
                                            This will not renew again, it
                                            expires{' '}
                                            {formatDateLong(grant.expires_at)}
                                        </div>
                                    )}
                                {!!grant.expires_at &&
                                    !isFuture(new Date(grant.expires_at)) && (
                                        <div>This is expired</div>
                                    )}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UsedPackageGrantDetails;
